import { EncounterNotes } from "@/store/modules/visitNote/interfaces/EncounterNotes";
import { MedicalInfo } from "@/store/modules/visitNote/interfaces/MedicalInfo";
import { PatientInfo } from "@/store/modules/visitNote/interfaces/PatientInfo";

import axios from "./axios";
interface UpdateBody {
  patientInformation: PatientInfo;
  medicalInformation: MedicalInfo;
  encounterNotes: EncounterNotes;
}

const update = async (visitNoteId: string, body: UpdateBody) => {
  const { data } = await axios.put(`/visitNote/${visitNoteId}`, body);
  return data;
};

const sign = async (visitNoteId: string) => {
  const { data } = await axios.post(`/visitNote/${visitNoteId}/sign`);
  return data;
};

const getById = async (appointmentId: string) => {
  const { data } = await axios.get(`/visitNote?appointmentId=${appointmentId}`);
  return data;
};

export const VisitNoteAPI = {
  update,
  sign,
  getById,
};
